export default __webpack_public_path__ + "static/media/Infineon.eed8c593.png";